module.exports = __webpack_public_path__ + "img/4-1.a9ce756b.png";